export default __webpack_public_path__ + "static/iso-9001-26d4a17460548a169e5506d055a7a354.svg";